var map = {
	"./card/p0101.png": 92819,
	"./card/p0102.png": 52893,
	"./card/p0103.png": 17066,
	"./card/p0104.png": 68485,
	"./card/p0201.png": 30175,
	"./card/p0202.png": 75389,
	"./card/p0301.png": 59117,
	"./card/p0302.png": 45125,
	"./card/p0303.png": 20590,
	"./card/p0304.png": 39733,
	"./card/p0401.png": 90442,
	"./card/p0402.png": 77793,
	"./card/p0403.png": 53781,
	"./card/p0404.png": 75983,
	"./card/p0501.png": 58546,
	"./card/p0502.png": 50356,
	"./card/p0503.png": 9023,
	"./card/p0504.png": 12352,
	"./card/p0601.png": 15029,
	"./card/p0602.png": 31234,
	"./card/p0603.png": 79675,
	"./card/p0604.png": 61339,
	"./card/p0701.png": 96163,
	"./card/p0702.png": 92186,
	"./card/p0703.png": 42551,
	"./card/p0704.png": 83303,
	"./card/p0801.png": 46659,
	"./card/p0802.png": 30922,
	"./card/p0803.png": 18878,
	"./card/p0804.png": 52228,
	"./card/p0901.png": 5242,
	"./card/p0902.png": 22961,
	"./card/p1001.png": 47522,
	"./card/p1002.png": 50566,
	"./card/p1003.png": 37869,
	"./card/p1004.png": 30802,
	"./card/p1101.png": 59756,
	"./card/p1102.png": 40124,
	"./card/p1103.png": 28115,
	"./card/p1104.png": 59587,
	"./card/p1201.png": 6669,
	"./card/p1202.png": 85803,
	"./card/p1301.png": 39112,
	"./card/p1302.png": 2557,
	"./card/p1303.png": 53036,
	"./card/p1304.png": 70582,
	"./card/p1401.png": 26624,
	"./card/p1402.png": 52199,
	"./card/p1501.png": 61960,
	"./card/p1502.png": 39753,
	"./lists/p0101.jpg": 95154,
	"./lists/p0102.jpg": 14386,
	"./lists/p0103.jpg": 43546,
	"./lists/p0104.jpg": 63008,
	"./lists/p0201.jpg": 13959,
	"./lists/p0202.jpg": 81979,
	"./lists/p0301.jpg": 3746,
	"./lists/p0302.jpg": 16565,
	"./lists/p0303.jpg": 71315,
	"./lists/p0304.jpg": 26643,
	"./lists/p0401.jpg": 13582,
	"./lists/p0402.jpg": 39336,
	"./lists/p0403.jpg": 43113,
	"./lists/p0404.jpg": 74234,
	"./lists/p0501.jpg": 80170,
	"./lists/p0502.jpg": 4022,
	"./lists/p0503.jpg": 84047,
	"./lists/p0504.jpg": 19490,
	"./lists/p0601.jpg": 55638,
	"./lists/p0602.jpg": 48443,
	"./lists/p0603.jpg": 63293,
	"./lists/p0604.jpg": 78531,
	"./lists/p0701.jpg": 68937,
	"./lists/p0702.jpg": 19953,
	"./lists/p0703.jpg": 90472,
	"./lists/p0704.jpg": 64934,
	"./lists/p0801.jpg": 77932,
	"./lists/p0802.jpg": 83187,
	"./lists/p0803.jpg": 87168,
	"./lists/p0804.jpg": 93874,
	"./lists/p0901.jpg": 7573,
	"./lists/p0902.jpg": 31760,
	"./lists/p1001.jpg": 64643,
	"./lists/p1002.jpg": 90079,
	"./lists/p1003.jpg": 26665,
	"./lists/p1004.jpg": 29809,
	"./lists/p1101.jpg": 43339,
	"./lists/p1102.jpg": 98137,
	"./lists/p1103.jpg": 6878,
	"./lists/p1104.jpg": 90264,
	"./lists/p1201.jpg": 54661,
	"./lists/p1202.jpg": 90349,
	"./lists/p1301.jpg": 3114,
	"./lists/p1302.jpg": 25261,
	"./lists/p1303.jpg": 14606,
	"./lists/p1304.jpg": 63298,
	"./lists/p1401.jpg": 94036,
	"./lists/p1402.jpg": 7004,
	"./lists/p1501.jpg": 1790,
	"./lists/p1502.jpg": 72678,
	"./ui/activity-bg.jpg": 93942,
	"./ui/activity-gift.png": 34947,
	"./ui/airdrop-bg.jpg": 96339,
	"./ui/airdrop-invite.png": 63821,
	"./ui/airdrop-status-ended.png": 86853,
	"./ui/airdrop-status-notStarted.png": 87142,
	"./ui/airdrop-status-pedding.png": 46570,
	"./ui/airdrop-status-prizedrawm.png": 18531,
	"./ui/airdrop-time.png": 55355,
	"./ui/arena-head-bg.jpg": 61518,
	"./ui/arena-head-left.png": 53629,
	"./ui/arena-head-right.png": 52012,
	"./ui/arena-head-s.png": 45065,
	"./ui/arena-head-v.png": 70375,
	"./ui/assets-bg.jpg": 39676,
	"./ui/award_tip.png": 96062,
	"./ui/battle-bg.jpg": 61475,
	"./ui/battle-defeat-bg.png": 72834,
	"./ui/battle-head-attack-bg.png": 94628,
	"./ui/battle-head-defender-bg.png": 95658,
	"./ui/battle-head-vs.png": 79395,
	"./ui/battle-icon-honor.png": 67051,
	"./ui/battle-icon-power.png": 57727,
	"./ui/battle-record-icon-defeat.png": 70325,
	"./ui/battle-record-icon-victory.png": 58176,
	"./ui/battle-victory-bg.png": 56616,
	"./ui/battle-victory-crown.png": 9791,
	"./ui/battle-victory-ribbon.png": 4493,
	"./ui/battle-victory-text.png": 80590,
	"./ui/battle-victory-wing.png": 54943,
	"./ui/battleEffect/0.png": 61336,
	"./ui/battleEffect/1.png": 13889,
	"./ui/battleEffect/2.png": 3347,
	"./ui/btn-activity-bg.png": 53669,
	"./ui/btn-airdrop-bg.png": 59540,
	"./ui/btn-airdrop.png": 85135,
	"./ui/btn-close.png": 81554,
	"./ui/btn-draw-1-bg.png": 81405,
	"./ui/btn-draw-2-bg.png": 34557,
	"./ui/btn-draw-3-bg.png": 23192,
	"./ui/btn-draw-one.png": 6219,
	"./ui/btn-draw-ten.png": 66006,
	"./ui/btn-join-bg.png": 51838,
	"./ui/btn-jump.png": 67643,
	"./ui/btn-mint.png": 74765,
	"./ui/btn-pay-bg.png": 56758,
	"./ui/btn-pay-diamond-info.png": 43680,
	"./ui/btn-shop-bg.png": 69565,
	"./ui/btn-task-bg.png": 88633,
	"./ui/btn-upgrade-bg.png": 60186,
	"./ui/btn-upgrade-star-bg.png": 91594,
	"./ui/card-back.png": 46269,
	"./ui/chip-1.png": 87422,
	"./ui/chip.png": 55531,
	"./ui/daily-icon-card.png": 28086,
	"./ui/daily-icon-info.png": 89714,
	"./ui/daily-icon-ok.png": 46281,
	"./ui/daily-signed-bg.jpg": 12954,
	"./ui/daily-today-bg.jpg": 56683,
	"./ui/detail-bg.jpg": 50518,
	"./ui/diamond-1.png": 1909,
	"./ui/diamond-2.png": 33627,
	"./ui/diamond-3.png": 92003,
	"./ui/diamond-4.png": 91993,
	"./ui/enery_invite.png": 60547,
	"./ui/friend-bg.jpg": 49775,
	"./ui/friend-btn-copy.png": 39114,
	"./ui/friend-btn-invite.png": 57443,
	"./ui/friend-item-bg.jpg": 65951,
	"./ui/guide-hand.png": 46760,
	"./ui/icon-ads.png": 32007,
	"./ui/icon-airdop-invite.png": 18861,
	"./ui/icon-airdrop.png": 47003,
	"./ui/icon-anim-upgrade.png": 91082,
	"./ui/icon-anim-upgrade_1.png": 24292,
	"./ui/icon-arena-filter.png": 10646,
	"./ui/icon-arena-lock.png": 32506,
	"./ui/icon-arena-power.png": 17877,
	"./ui/icon-arena-record.png": 71527,
	"./ui/icon-arena.png": 93876,
	"./ui/icon-copy.png": 50710,
	"./ui/icon-diamonds.png": 26987,
	"./ui/icon-energy.png": 78163,
	"./ui/icon-gold.png": 16404,
	"./ui/icon-info.png": 90563,
	"./ui/icon-invite.png": 90142,
	"./ui/icon-mint.png": 34464,
	"./ui/icon-pay.png": 74084,
	"./ui/icon-power-new.png": 70946,
	"./ui/icon-power.png": 45668,
	"./ui/icon-question.png": 81433,
	"./ui/icon-quit.png": 56423,
	"./ui/icon-ranking.png": 27976,
	"./ui/icon-record.png": 79325,
	"./ui/icon-shop.png": 92062,
	"./ui/icon-task.png": 88515,
	"./ui/icon-time.png": 45747,
	"./ui/icon-ton.png": 48514,
	"./ui/icon-usdt.png": 22130,
	"./ui/icon-wallet.png": 98418,
	"./ui/item-bg.png": 86269,
	"./ui/item-level.png": 26714,
	"./ui/join-g.png": 3391,
	"./ui/light.png": 89937,
	"./ui/menu-arena-active1.png": 88422,
	"./ui/menu-arena.png": 60742,
	"./ui/menu-assets-active1.png": 34854,
	"./ui/menu-assets.png": 39699,
	"./ui/menu-backpack-active1.png": 98719,
	"./ui/menu-backpack.png": 32911,
	"./ui/menu-friend-active1.png": 22359,
	"./ui/menu-friend.png": 20860,
	"./ui/menu-home-active1.png": 3098,
	"./ui/menu-home.png": 95847,
	"./ui/menu-mining-active1.png": 70331,
	"./ui/menu-mining.png": 24539,
	"./ui/menu-rank-active1.png": 5365,
	"./ui/menu-rank.png": 20918,
	"./ui/mining/logo/binance.png": 27528,
	"./ui/mining/logo/bitget.png": 13230,
	"./ui/mining/logo/gate.png": 16745,
	"./ui/mining/logo/okx.png": 25078,
	"./ui/mining/logo/stonfi.png": 37696,
	"./ui/mining/mining-head-img.jpg": 91662,
	"./ui/mining/mining-q-1.jpg": 89786,
	"./ui/mining/mining-q-1.png": 67973,
	"./ui/mining/mining-q-2.png": 90082,
	"./ui/mining/mining-q-3.png": 24831,
	"./ui/mining/mining-q-4.png": 33338,
	"./ui/mining/mining-q-5.png": 46265,
	"./ui/name-bg.png": 20111,
	"./ui/nav-btn-bg-1.png": 21829,
	"./ui/nav-btn-bg-2.png": 17809,
	"./ui/nav-btn-bg-3.png": 67157,
	"./ui/nav-btn-bg-4.png": 66227,
	"./ui/pony.png": 39467,
	"./ui/ponyverse.png": 28383,
	"./ui/pop-btn-upgrade-bg.png": 36521,
	"./ui/pop-btn-upgrade-star-bg.png": 27631,
	"./ui/pop-upgrade-arrow.png": 17091,
	"./ui/pop-upgradestar-star-bg.png": 71262,
	"./ui/popPayDiamondInfo.jpg": 33919,
	"./ui/rank-1.png": 84089,
	"./ui/rank-2.png": 987,
	"./ui/rank-3.png": 27269,
	"./ui/rank-head-bg.jpg": 41554,
	"./ui/rarity-1.png": 29030,
	"./ui/rarity-2.png": 45760,
	"./ui/rarity-3.png": 12668,
	"./ui/rarity-4.png": 53777,
	"./ui/rarity-5.png": 91389,
	"./ui/rarity-bg.png": 78347,
	"./ui/rarity-text-1.png": 90363,
	"./ui/rarity-text-2.png": 59497,
	"./ui/rarity-text-3.png": 1183,
	"./ui/rarity-text-4.png": 38987,
	"./ui/rarity-text-5.png": 42662,
	"./ui/reward-card-img.png": 39393,
	"./ui/reward-coin-img.png": 64758,
	"./ui/reward-coin-question.png": 72346,
	"./ui/reward-icon-watch.png": 94117,
	"./ui/reward-pony-img.png": 50965,
	"./ui/reward-usdt-img.png": 1089,
	"./ui/shop-bg.jpg": 46613,
	"./ui/star-bg.png": 37773,
	"./ui/star.png": 94008,
	"./ui/task-img.jpg": 37495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;